<template>
  <!-- tips容器 -->
  <div id="J-tips" class="ui-topic" style="z-index:9999"
  :style="{ left: css.left, top : css.top}"
  v-show="visible">
    <div class="inner_html tip-container">
        <div class="content" :class="type" v-html="tips_contxt"></div>
    </div>
  </div>
  <!-- end -->
</template>

<style scoped>
    .ui-topic {
        background: rgba(0, 0, 0, 0.8);
        color: #fff;
        position: absolute;
        top: 100px;
        left: 200px;
        border: 1px solid #7c6c49;
    }

    .ui-topic .inner_html {
        line-height: 20px;
        font-size: 12px;
        color: #fff;
        font-family: arial;
    }

    .ui-topic .inner_html .img{
        width: max-content;
        font-size: 0;
        line-height: 0;
    }

    /* .ui-topic .inner_html a {
        color: #fff;
        font-weight: bold;
        text-decoration: none;
        border-bottom: 1px dotted #990000;
    }

    .ui-topic .inner_html a:hover {
        border-bottom: 2px solid #990000;
    }

    .ui-topic {
        color: #00ff00;
    }

    .ui-topic .itemDesc {
        width: 300px;
        margin-top: 10px;
        color: #a1e5ff;
    }

    .ui-topic .type2 {
        color: #fff;
    }

    .ui-topic .type3 {
        margin-bottom: 10px;
    }

    .ui-topic .green,
    .ui-topic .strength,
    .ui-topic .agility,
    .ui-topic .mentality,
    .ui-topic .iniMovementSpeed,
    .ui-topic .healthPoint,
    .ui-topic .manaPerSecond,
    .ui-topic .skillStats,
    .ui-integralAddition,
    .ui-topic .smPerSecond,
    .fightingCapAdd {
        color: #00ff00;
    }

    .ui-topic .skillAdd1 {
        margin-top: 10px;
    }

    .ui-topic .skillAdd1,
    .ui-topic .skillAdd2 {
        width: 260px;
    }

    .ui-topic .skillAdd1,
    .ui-topic .skillAdd2 {
        color: #0088ff;
    }

    .ui-topic .purple {
        color: #9205EA;
    }

    .ui-topic .gold,
    .ui-topic .type3 {
        color: #FFCC11;
    }

    .ui-topic .dGold {
        color: #dd9955;
    }

    .ui-topic .orange,
    .ui-topic .magicValue {
        color: #FF8800;
    }

    .ui-topic .blue {
        color: #0088ff;
    }

    .ui-topic .desc {
        max-width: 300px;
        word-break: break-all;
    } */

</style>

<script>
export default {
    name : 'tips-pc',
    data (){
        return {
            css : {
                left : '',
                top : '',
                width : '100px',
            },
            visible : false,
            item_id : '',
            data : () => {},
            tips_contxt : '',
            text : '',
            type : 'text',
            src : 'https://web-resource.17m3.com/m3guo/202203/signup/tips/',  
            pos_data : {
                x : 0,
                y : 0,
            },
            img_width : 0,
            ready : false,
        }
    },   
    watch: {
        pos_data (newVal) {
            if (newVal) {
                this.setPosition(this.pos_data.x,this.pos_data.y);
            }
        },
        item_id (newVal){
            var self = this;
            if (newVal) {
                self.visible = false;
                var temp = new Image();
                temp.src = this.src + this.item_id +'.png';

                // if(temp.complete) {  
                //     self.setHtml (newVal); 
                // }
                
                temp.onload = function(){
                    self.setHtml (newVal);
                    self.img_width = temp.width;
                    self.visible = true;
                }
                //this.setHtml (newVal);
            }            
        }  
    },    
    mounted (){       
        this.setPosition(this.pos_data.x,this.pos_data.y);
    },
    methods :{
      setPosition: function (x, y) {

        var topic = document.querySelector('#J-tips');

        var top = document.body.scrollTop || document.documentElement.scrollTop;
        var left = document.body.scrollLeft || document.documentElement.scrollLeft;

        x += left;
        y += top;

        var l = x - (this.img_width + 20);
        var t = y - (topic.clientHeight * 0.5 + 100);
        var bRight = true;
        var bTop = true;
        var iPageRight = left + document.documentElement.clientWidth;
        var iPageTop = top + document.documentElement.clientHeight;

        if (l + topic.clientWidth > iPageRight) {
          bRight = false;

          l = x - (topic.clientWidth + 20);
        }

        if (t - topic.clientHeight < 0) {
          bTop = false;
          t = y - 10 - topic.clientHeight * 0.5;
        }


        this.css.left = l + 'px' // 减去外层div的left距离
        this.css.top = t + 'px'
      },
        fuckTipsTxtFormat(text){

            if(!text)return '详细内容见游戏';

            return text
            .replace(/\|r\|n\|cff99d3ff\s\|r\d{0,2}\.{0,1}\|pUI.*?\|e\|(\w{9})/gi, '|r|n|$1')
            .replace(/\|r\|pUI(.*?)\|e\|\S*/g, '').replace(/\|n/g, '<br/>')
            .replace(/\|cff(\w{6})/gi, '<span style="color:#$1">')
            .replace(/\|r/g, '</span>');
        },
        getContext (id){
            let vm = this;
            if(!tips_data[vm.item_id]){
                vm.tips_contxt = '';
                vm.$axios({
                    method: 'get',
                    url: ajax_url_map.tips,
                    params:{
                        id : vm.item_id,
                        '_': +new Date(),
                    },
                    withCredentials: true,
                    responseType: 'json',
                    headers: {},
                })
                .then(res => {
                        if(res.code == 1){
                            //success
                            vm.data = res.data[0];

                            tips_data[id] = res.data[0];
                            vm.setHtml();
                        }
                    },rej => {
                        //sick code
                    })
                .catch(err=>{
                    console.error(err);
                })          
            }
            else{
                vm.data = tips_data[vm.item_id];
                vm.setHtml();
            }            
        },
        setHtml (){
            var temp = this.data ? this.data.desc : '详细内容见游戏';
            this.text = this.type != 'img' ? temp : '';
            this.tips_contxt = this.type != 'img' ? this.fuckTipsTxtFormat(this.text) : '<div class="img"><img src="'+ this.src + this.item_id +'.png" style="width:100%"></div>';            
        },           
    },
}
</script>


// WEBPACK FOOTER //
// src/components/ItemTipsPC/itemTipsPC.vue